import { useEffect, useMemo, useRef, useState } from "react";

import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import { LOGIN_CONTENT_PADDING } from "CrossFeatureComponents/MemberToolbar/styleConstants";

import FnrFade from "UI/FnrFade";
import FnrSlides from "UI/FnrSlides";

import { Divider } from "../shared";

import ContactForm from "./ContactForm";
import ContactMenu from "./ContactMenu";
import Login from "./Login";
import MemberPortalNav from "./MemberPortalNav";
import MessageSent from "./MessageSent";
import { UserMenu } from "./UserMenu/UserMenu";

const activeContentSwitchConfig = [
  { key: contentKeys.nothing, value: () => null },
  { key: contentKeys.user, value: UserMenu },
  { key: contentKeys.login, value: Login },
  { key: contentKeys.contact, value: ContactMenu },
  { key: contentKeys.form, value: ContactForm, keepInDOM: true },
  { key: contentKeys.messageSent, value: MessageSent },
  { key: contentKeys.memberPortalNav, value: MemberPortalNav },
];

const ActiveContent = () => {
  const { activeContentKey: activeContentKeyState } = useMemberToolbarStore();

  const [activeContentKeyLocal, setActiveContentKeyLocal] = useState(
    activeContentKeyState
  );
  const [variant, setVariant] = useState("fade");
  const timeoutRef = useRef();
  const prevActiveContentKeyState = useRef(activeContentKeyState);

  useEffect(() => {
    const prevKey = prevActiveContentKeyState.current;
    const currentKey = activeContentKeyState;

    setActiveContentKeyLocal(currentKey);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (prevKey === "nothing" && currentKey !== "nothing") {
      setVariant("fade");
    } else if (prevKey !== "nothing" && currentKey === "nothing") {
      setVariant("fade");
    } else if (prevKey !== "nothing" && currentKey !== "nothing") {
      timeoutRef.current = setTimeout(() => setVariant("standard"), 100);
    }

    prevActiveContentKeyState.current = currentKey;

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [activeContentKeyState]);

  const isUserContent = useMemo(
    () =>
      activeContentKeyState !== "nothing" && activeContentKeyState !== "login",
    [activeContentKeyState]
  );

  // const hasActiveContent = useHasActiveContent();
  const hasActiveContent = useMemo(
    () => activeContentKeyState !== "nothing",
    [activeContentKeyState]
  );

  return (
    <>
      <FnrSlides
        sizeSpring={hasActiveContent} // only spring when going from nothing to something
        activeKey={activeContentKeyLocal}
        variant={variant}
        fullWidth
        components={activeContentSwitchConfig}
      />
      <FnrFade show={isUserContent}>
        <Divider marginX={12} />
      </FnrFade>
    </>
  );
};

export { ActiveContent, LOGIN_CONTENT_PADDING };
